// 產生整朵蓮花與菩提葉的 <canvas> 圖形，供 react-snowfall 的 images prop 使用

// 蓮花花瓣的 SVG path 資料，依真實蓮花側視線稿手繪校準（340x340 原始座標系，花心約在 170,230）。
// 每片花瓣是柳葉狀、底部有寬度不收尖成單點，由外而內、左右對稱分七層展開，
// 層數越外圈瓣越寬扁側傾，越內圈瓣越窄直立，符合真實蓮花盛開時的層次。
const LOTUS_VIEWBOX = { width: 340, height: 340, cx: 170, cy: 230 };
const LOTUS_PETALS = [
    { layer: 0, d: 'M 136,230 Q 136.35,219.49 130.67,219.67 C 115.52,202.46 95.37,199.89 74.26,201.85 Q 50.99,213.98 44.35,218.7 Q 48.5,225.71 68.15,230.61 C 86.64,240.98 106.09,246.83 126.93,237.27 Q 132.05,239.74 136,230 Z' },
    { layer: 0, d: 'M 204,230 Q 207.95,239.74 213.07,237.27 C 233.91,246.83 253.36,240.98 271.85,230.61 Q 291.5,225.71 295.65,218.7 Q 289.01,213.98 265.74,201.85 C 244.63,199.89 224.48,202.46 209.33,219.67 Q 203.65,219.49 204,230 Z' },
    { layer: 1, d: 'M 141,230 Q 143.75,220.39 137.64,218.59 C 125.43,197.26 104.48,187.93 81.46,182.48 Q 53.74,185.87 45.42,188.24 Q 48.11,196.47 68.31,207.21 C 85.7,223.25 105.15,235.4 129.66,233.6 Q 134.57,237.65 141,230 Z' },
    { layer: 1, d: 'M 199,230 Q 205.43,237.65 210.34,233.6 C 234.85,235.4 254.3,223.25 271.69,207.21 Q 291.89,196.47 294.58,188.24 Q 286.26,185.87 258.54,182.48 C 235.52,187.93 214.57,197.26 202.36,218.59 Q 196.25,220.39 199,230 Z' },
    { layer: 2, d: 'M 147,230 Q 151.02,222.01 145,218.11 C 136.18,192.64 115.87,176.4 92.76,163.27 Q 64.57,155.78 55.29,155.5 Q 56.54,164.7 74.96,183.03 C 90.44,204.64 108.72,223.14 134.97,229.26 Q 139.47,234.83 147,230 Z' },
    { layer: 2, d: 'M 193,230 Q 200.53,234.83 205.03,229.26 C 231.28,223.14 249.56,204.64 265.04,183.03 Q 283.46,164.7 284.71,155.5 Q 275.43,155.78 247.24,163.27 C 224.13,176.4 203.82,192.64 195,218.11 Q 188.98,222.01 193,230 Z' },
    { layer: 3, d: 'M 153,230 Q 157.52,223.5 152.15,217.77 C 146.9,189.44 128.95,167.13 107.89,147.08 Q 81.98,130.55 72.54,127.77 Q 72.27,137.6 88.07,161.48 C 100.64,187.7 116.31,211.66 141.63,225.41 Q 145.42,232.29 153,230 Z' },
    { layer: 3, d: 'M 187,230 Q 194.58,232.29 198.37,225.41 C 223.69,211.66 239.36,187.7 251.93,161.48 Q 267.73,137.6 267.46,127.77 Q 258.02,130.55 232.11,147.08 C 211.05,167.13 193.1,189.44 187.85,217.77 Q 182.48,223.5 187,230 Z' },
    { layer: 4, d: 'M 159,230 Q 163.62,224.83 159.4,217.39 C 158.61,186.65 144.74,158.63 127.65,132.04 Q 107.45,106.84 98.5,101.5 Q 96.49,111.72 107.18,141.15 C 115.5,171.65 127.04,200.71 149.35,221.86 Q 152.07,229.98 159,230 Z' },
    { layer: 4, d: 'M 181,230 Q 187.93,229.98 190.65,221.86 C 212.96,200.71 224.5,171.65 232.82,141.15 Q 243.51,111.72 241.5,101.5 Q 232.55,106.84 212.35,132.04 C 195.26,158.63 181.39,186.65 180.6,217.39 Q 176.38,224.83 181,230 Z' },
    { layer: 5, d: 'M 165,230 Q 169.43,225.95 166.87,217.17 C 170.41,185.34 162.4,152.85 151.49,120.99 Q 139.21,89.41 131.44,81.74 Q 127.47,91.91 133,124.92 C 135.99,158.47 141.89,191.4 158.07,219.04 Q 159.31,228.1 165,230 Z' },
    { layer: 5, d: 'M 175,230 Q 180.69,228.1 181.93,219.04 C 198.11,191.4 204.01,158.47 207,124.92 Q 212.53,91.91 208.56,81.74 Q 200.79,89.41 188.51,120.99 C 177.6,152.85 169.59,185.34 173.13,217.17 Q 170.57,225.95 175,230 Z' },
    { layer: 6, d: 'M 168,230 Q 171.25,227.05 170.23,218.94 C 176.12,191.26 173.23,161.47 168.15,131.83 Q 164.07,102.12 157.52,94.4 Q 152.1,102.96 154.19,132.81 C 153.28,162.86 154.57,192.77 164.25,219.36 Q 164.37,227.53 168,230 Z' },
    { layer: 6, d: 'M 172,230 Q 175.63,227.53 175.75,219.36 C 185.43,192.77 186.72,162.86 185.81,132.81 Q 187.9,102.96 182.48,94.4 Q 175.93,102.12 171.85,131.83 C 166.77,161.47 163.88,191.26 169.77,218.94 Q 168.75,227.05 172,230 Z' },
];
const LOTUS_LAYER_COUNT = 7;

/**
 * 畫一整朵蓮花（側視完全綻放，依真實蓮花線稿校準的柳葉狀花瓣，層次分明、辨識度高）
 * Draws a fully bloomed lotus flower (side view, petal shapes calibrated against a real lotus reference)
 */
function drawLotusFlower(ctx, size, color) {
    // 原始 path 是在 340x340、花心 (170,230) 的座標系繪製，這裡等比縮放並平移到目標 size 畫布
    const scale = size / LOTUS_VIEWBOX.width;
    const offsetX = size / 2 - LOTUS_VIEWBOX.cx * scale;
    const offsetY = size * 0.56 - LOTUS_VIEWBOX.cy * scale;

    ctx.save();
    ctx.translate(offsetX, offsetY);
    ctx.scale(scale, scale);

    LOTUS_PETALS.forEach(({ layer, d }) => {
        const path = new Path2D(d);
        const t = layer / (LOTUS_LAYER_COUNT - 1);
        // 外層（t=0）色最深，內層（t=1）色最淺，模擬花瓣層層透光漸亮
        const fill = shadeColor(color, -24 + t * 46);

        // 每層花瓣先投一層柔和陰影，製造前後層次的深度感
        ctx.save();
        ctx.shadowColor = 'rgba(60,30,10,0.3)';
        ctx.shadowBlur = 6 + layer * 1.2;
        ctx.shadowOffsetY = 3 + layer * 0.6;
        ctx.fillStyle = fill;
        ctx.fill(path);
        ctx.restore();

        // 弧面受光漸層：花瓣中軸偏亮、邊緣偏暗，強化立體感
        const grad = ctx.createLinearGradient(170 - 60, 230, 170 + 60, 230);
        grad.addColorStop(0, 'rgba(255,255,255,0.22)');
        grad.addColorStop(0.5, 'rgba(255,255,255,0.06)');
        grad.addColorStop(1, 'rgba(0,0,0,0.16)');
        ctx.fillStyle = grad;
        ctx.fill(path);

        ctx.strokeStyle = shadeColor(fill, -22);
        ctx.lineWidth = 1.4;
        ctx.globalAlpha = 0.55;
        ctx.stroke(path);
        ctx.globalAlpha = 1;
    });

    // 花蕊：花心周圍一圈細短雄蕊
    const cx = LOTUS_VIEWBOX.cx;
    const cy = 222;
    const stamenCount = 9;
    for (let i = 0; i < stamenCount; i++) {
        const a = Math.PI + (Math.PI * (i - (stamenCount - 1) / 2)) / (stamenCount * 1.4);
        const r1 = 8;
        const r2 = 22;
        const x1 = cx + Math.sin(a) * r1;
        const y1 = cy - Math.cos(a) * r1 * 0.7;
        const x2 = cx + Math.sin(a) * r2;
        const y2 = cy - Math.cos(a) * r2 * 0.7;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.strokeStyle = shadeColor(color, 32);
        ctx.lineWidth = 1.6;
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(x2, y2, 2.6, 0, Math.PI * 2);
        ctx.fillStyle = '#E8B84B';
        ctx.fill();
    }

    // 花心（蓮蓬）
    ctx.beginPath();
    ctx.ellipse(cx, cy, 16, 12, 0, 0, Math.PI * 2);
    ctx.fillStyle = shadeColor(color, 40);
    ctx.fill();
    ctx.strokeStyle = shadeColor(color, -10);
    ctx.lineWidth = 1.4;
    ctx.stroke();

    // 蓮蓬上的蓮子孔洞
    const seedPositions = [
        [0, 0], [-6, -4], [6, -4], [-6, 4], [6, 4], [0, -7],
    ];
    seedPositions.forEach(([dx, dy]) => {
        ctx.beginPath();
        ctx.arc(cx + dx, cy + dy, 1.8, 0, Math.PI * 2);
        ctx.fillStyle = shadeColor(color, -20);
        ctx.fill();
    });

    ctx.restore();
}

/**
 * 畫一片菩提葉：心形葉基＋兩側對稱葉緣＋標誌性的細長滴水葉尖
 * Draws a bodhi leaf: heart-shaped base with a signature elongated drip tip
 */
function drawBodhiLeaf(ctx, size, color) {
    // s 縮小、並整體上移，預留底部空間給滴水尖＋葉柄，避免超出畫布
    const s = size * 0.36;
    const stemLen = size * 0.1;
    const cx = size / 2;
    const cy = size * 0.42;

    ctx.save();
    ctx.translate(cx, cy);

    ctx.beginPath();
    // 從滴水尖尾端開始（葉柄連接處，尖端縮短一些讓位給葉柄）
    ctx.moveTo(0, s * 0.95);
    // 右側：滴水尖 -> 葉片最寬處
    ctx.quadraticCurveTo(s * 0.06, s * 0.65, s * 0.32, s * 0.5);
    ctx.bezierCurveTo(s * 0.75, s * 0.15, s * 0.85, -s * 0.35, s * 0.55, -s * 0.7);
    // 右側葉基凹陷（心形肩膀）
    ctx.bezierCurveTo(s * 0.35, -s * 0.95, s * 0.12, -s * 0.85, 0, -s * 0.55);
    // 左側葉基凹陷（對稱）
    ctx.bezierCurveTo(-s * 0.12, -s * 0.85, -s * 0.35, -s * 0.95, -s * 0.55, -s * 0.7);
    ctx.bezierCurveTo(-s * 0.85, -s * 0.35, -s * 0.75, s * 0.15, -s * 0.32, s * 0.5);
    ctx.quadraticCurveTo(-s * 0.06, s * 0.65, 0, s * 0.95);
    ctx.closePath();

    ctx.fillStyle = color;
    ctx.fill();
    ctx.strokeStyle = shadeColor(color, -18);
    ctx.lineWidth = Math.max(0.5, size * 0.004);
    ctx.globalAlpha = 0.5;
    ctx.stroke();
    ctx.globalAlpha = 1;

    // 葉柄：從滴水尖尾端再延伸一小段細梗
    ctx.beginPath();
    ctx.moveTo(0, s * 0.9);
    ctx.quadraticCurveTo(s * 0.02, s * 0.95 + stemLen * 0.5, 0, s * 0.95 + stemLen);
    ctx.strokeStyle = shadeColor(color, -30);
    ctx.lineWidth = Math.max(1, size * 0.018);
    ctx.lineCap = 'round';
    ctx.stroke();

    // 中央主葉脈：從葉基一路到滴水尖尖端
    ctx.beginPath();
    ctx.moveTo(0, -s * 0.6);
    ctx.lineTo(0, s * 0.9);
    ctx.strokeStyle = shadeColor(color, -25);
    ctx.lineWidth = Math.max(1, size * 0.012);
    ctx.stroke();

    // 側脈（斜向葉緣，各 2 條）：只取葉片較寬的上半部，避免脈線甩出滴水尖收窄的輪廓外
    ctx.strokeStyle = shadeColor(color, -15);
    ctx.lineWidth = Math.max(0.6, size * 0.006);
    const veinStarts = [-s * 0.4, -s * 0.1];
    veinStarts.forEach((y0) => {
        [1, -1].forEach((dir) => {
            ctx.beginPath();
            ctx.moveTo(0, y0);
            ctx.quadraticCurveTo(dir * s * 0.22, y0 + s * 0.18, dir * s * 0.38, y0 + s * 0.4);
            ctx.stroke();
        });
    });

    ctx.restore();
}

function shadeColor(hex, percent) {
    const num = parseInt(hex.replace('#', ''), 16);
    let r = (num >> 16) + percent;
    let g = ((num >> 8) & 0x00ff) + percent;
    let b = (num & 0x0000ff) + percent;
    r = Math.max(0, Math.min(255, r));
    g = Math.max(0, Math.min(255, g));
    b = Math.max(0, Math.min(255, b));
    return `#${(1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1)}`;
}

// 蓮花已改用 recolor.js 對成熟美術素材（B 素材）重上色，不再使用 drawLotusFlower 程式繪製；
// 這裡只保留菩提葉的手繪邏輯，createShapeCanvas 目前僅供 type='bodhi' 呼叫。
const DRAWERS = { bodhi: drawBodhiLeaf };

/**
 * 產生指定形狀的 <canvas> 元素
 * Creates a <canvas> element for the given shape
 */
export function createShapeCanvas(type, size = 96, color = '#F5C97B') {
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    const draw = DRAWERS[type] ?? DRAWERS.bodhi;
    draw(ctx, size, color);
    return canvas;
}

export { drawLotusFlower, drawBodhiLeaf, shadeColor };
